import React, { Component } from "react";
import { connect } from "react-redux";
import { updateCart, removeFromCart, saveCart } from "../actions/cartActions";
import { withTranslation } from 'react-i18next';
import MenuCartLine from "../components/MenuCartLine";
import MobileCartLine from "../components/MobileCartLine";
import WebCartLine from "../components/WebCartLine";

class CartLine extends Component {
    constructor(props) {
        super(props);
        const { line } = this.props;
        this.state = {
            totalQuantityPrice: line.product.specialPrice * line.quantity,
            quantity: line.quantity
        };

        this.onQuantityChange = this.onQuantityChange.bind(this);
        this.onRemoveLine = this.onRemoveLine.bind(this);
    }

    onQuantityChange(e) {
        const { product, stockItemId } = this.props.line;
        const newQuantity = parseInt(e.target.value, 10);
        this.setState({
            quantity: newQuantity,
            totalQuantityPrice: newQuantity * product.specialPrice
        });

        this.props.updateCart(stockItemId, newQuantity);
    }

    onRemoveLine(e) {
        const { line, settings } = this.props;

        if (window.gtag) {
            window.gtag('event', 'remove_from_cart', {
                currency: settings.isoCurrencySymbol,
                items: [{
                    item_id: line.product.stockItemCode,
                    item_name: line.product.title,
                    item_category: line.product.groupName,
                    price: line.product.specialPrice,
                    currency: settings.isoCurrencySymbol,
                    quantity: line.quantity
                }],
                value: line.product.specialPrice
            });
        }

        this.props.removeFromCart(line.stockItemId);
    }

    render() {
        const { line, isReadOnly, isMenu, isMobile, settings } = this.props;
        if (!line) return <div />;

        if (isMenu) {
            return <MenuCartLine line={line} onRemoveLine={this.onRemoveLine} settings={settings} />
        }

        if (isMobile) {
            return <MobileCartLine line={line} isReadOnly={isReadOnly} totalQuantityPrice={this.state.totalQuantityPrice}
                onRemoveLine={this.onRemoveLine} onQuantityChange={this.onQuantityChange} settings={settings} />
        }

        return <WebCartLine line={line} isReadOnly={isReadOnly} totalQuantityPrice={this.state.totalQuantityPrice}
            onRemoveLine={this.onRemoveLine} onQuantityChange={this.onQuantityChange} settings={settings} />


    }
}

function mapStateToProps({ cart, user, settings }, ownProps) {
    return { cart, user, settings, ...ownProps };
}

export default withTranslation()(connect(mapStateToProps, { updateCart, removeFromCart, saveCart })(CartLine));
